import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

import { fetchSubscriptionEmployerTopUp, addSubscriptionEmployerTopUp, deleteSubscriptionEmployerTopUp, updateSubscriptionEmployerTopUp } from "./SubscriptionEmployerTopUpAPI"

const initialState = {
    data: [],
    loading: false,
    pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
    },
    error: null,
}

export const fetchSubscriptionEmployerTopUpAsync = createAsyncThunk(
    "subscriptionTopUp/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchSubscriptionEmployerTopUp()
            return response.data
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

export const addSubscriptionEmployerTopUpAsync = createAsyncThunk(
    "subscriptionTopUp/add",
    async (newSubscription, { rejectWithValue }) => {
        try {
            const response = await addSubscriptionEmployerTopUp(newSubscription)
            return response
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

export const updateSubscriptionEmployerTopUpAsync = createAsyncThunk(
    "subscription/update",
    async ({ id, updateSubscriptiondata }, { rejectWithValue }) => {
        try {
            const response = await updateSubscriptionEmployerTopUp(id, updateSubscriptiondata)
            return response
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

export const deleteSubscriptionEmployerTopUpAsync = createAsyncThunk(
    "subscriptionTopUp/delete",
    async (id, { rejectWithValue }) => {
        try {
            const response = await deleteSubscriptionEmployerTopUp(id)
            return response
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

const subscriptionEmployerTopUpSlice = createSlice({
    name: "subscriptionEmployerTopUp",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch cases
            .addCase(fetchSubscriptionEmployerTopUpAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchSubscriptionEmployerTopUpAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
                state.error = null
            })
            .addCase(fetchSubscriptionEmployerTopUpAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Add cases
            .addCase(addSubscriptionEmployerTopUpAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(addSubscriptionEmployerTopUpAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = [...state.data, action.payload]
                state.error = null
            })
            .addCase(addSubscriptionEmployerTopUpAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Update cases
            .addCase(updateSubscriptionEmployerTopUpAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(updateSubscriptionEmployerTopUpAsync.fulfilled, (state, action) => {
                state.loading = false
                const updatedPlan = action.payload
                state.data = state.data.map((plan) => (plan.uuid === updatedPlan.uuid ? updatedPlan : plan))
                state.error = null
            })
            .addCase(updateSubscriptionEmployerTopUpAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Delete cases
            .addCase(deleteSubscriptionEmployerTopUpAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(deleteSubscriptionEmployerTopUpAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = state.data.filter((item) => item.uuid !== action.payload.id)
                state.error = null
            })
            .addCase(deleteSubscriptionEmployerTopUpAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    },
})

export const selectSubscriptionEmployerTopUp = (state) => state.subscriptionEmployerTopUp.data
export default subscriptionEmployerTopUpSlice.reducer
